import type { AgeSummaryShellProps } from '@/modules/admin/pages/components/AgeSummaryShell/AgeSummaryShell.types'

import { AgeSummary } from '@/components/@Shared/UserManagmentCharts/AgeSummary/AgeSummary'

import { useAdminStatsServiceAdminStatsControllerGetAgeStats } from '@/__generated__/queries'

export function AgeSummaryShell({
  company,
  onUpdateChartsData,
}: AgeSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useAdminStatsServiceAdminStatsControllerGetAgeStats({
      company,
    })

  return (
    <AgeSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
